import { DestroyRef, inject, Injectable, signal } from '@angular/core'

import { IUser, UserListSchema } from '../schemas'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private api = inject(ApiService)
  private routes = this.api.routes.users
  private destroyRef = inject(DestroyRef)

  private _users = signal<IUser[]>([])
  public users = this._users.asReadonly()

  constructor() {
    const usersSub = this.api
      .request('GET', this.routes.list, UserListSchema)
      .subscribe({ next: (users) => this._users.set(users) })

    this.destroyRef.onDestroy(() => usersSub.unsubscribe())
  }

  getUserById(id?: number) {
    return this._users().find((u) => u.id === id)
  }
}
